import { NgModule } from '@angular/core';
import { RouterModule, Routes, withComponentInputBinding } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { InfoArrendamientosComponent } from './components/info-arrendamientos/info-arrendamientos.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PlanesSegurosComponent } from './components/planes-seguros/planes-seguros.component';
import { ResumenCompraComponent } from './components/resumen-compra/resumen-compra.component';
import { DuracionContratoComponent } from './components/duracion-contrato/duracion-contrato.component';
import { MessagesComponent } from './components/messages/messages.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { ArmarPlanComponent } from './components/armar-plan/armar-plan.component';
import { DatosPropietarioComponent } from './components/datos-propietario/datos-propietario.component';
import { ConexionInterrumpidaComponent } from './components/FinFlujo/conexion-interrumpida/conexion-interrumpida.component';
import { FinFlujoComponent } from './components/FinFlujo/fin-flujo/fin-flujo.component';
import { CotizacionPausaComponent } from './components/FinFlujo/cotizacion-pausa/cotizacion-pausa.component';
import { TiempoInactivoComponent } from './components/FinFlujo/tiempo-inactivo/tiempo-inactivo.component';
import { ErrorComponent } from './components/FinFlujo/error/error.component';
import { FinFlujoPEPComponent } from './components/FinFlujo/fin-flujoPEP/fin-flujoPEP.component';
import { FinFlujoPEmbComponent } from './components/FinFlujo/fin-flujoPEmb/fin-flujoPEmb.component';
import { ScoreFinancieroComponent } from './components/FinFlujo/score-financiero/score-financiero.component';
import { NoSarlaftComponent } from './components/FinFlujo/no-sarlaft/no-sarlaft.component';
import { CumuloComponent } from './components/FinFlujo/cumulo/cumulo.component';
import { InfoInmuebleComponent } from './components/info-inmueble/info-inmueble.component';
import { CardInmuebleComponent } from './components/card-inmueble/card-inmueble.component';
import { MensajePropietarioComponent } from './components/mensaje-propietario/mensaje-propietario.component';
import { DatosInquilinoComponent } from './components/datos-inquilino/datos-inquilino.component';
import { PagoExitosoComponent } from './components/pago-exitoso/pago-exitoso.component';
import { ProcesarPagoComponent } from './components/procesar-pago/procesar-pago.component';
import { PagoRechazadoComponent } from './components/pago-rechazado/pago-rechazado.component';
import { ResumenProcesoComponent } from './components/inquilino/resumen-proceso/resumen-proceso.component';
import { VerificacionNcelularComponent } from './components/inquilino/verificacion-ncelular/verificacion-ncelular.component';
import { ValidacionCodigoInquilinoComponent } from './components/inquilino/validacion-codigo-inquilino/validacion-codigo-inquilino.component';
import { PreguntasSeguridadComponent } from './components/inquilino/preguntas-seguridad/preguntas-seguridad.component';
import { FirmaContratoInquilinoComponent } from './components/inquilino/firma-contrato-inquilino/firma-contrato-inquilino.component';
import { DatosInquilinoInicialComponent } from './components/datos-inquilino-inicial/datos-inquilino-inicial.component';
import { NoValidacionIdentidadComponent } from './components/FinFlujo/no-validacion-identidad/no-validacion-identidad.component';
import { CotizacionPausa2Component } from './components/FinFlujo/cotizacion-pausa2/cotizacion-pausa2.component';
import { CotizacionPausa3Component } from './components/FinFlujo/cotizacion-pausa3/cotizacion-pausa3.component';
import { PuertaEntradaComponent } from './components/PruetaEntrada/puerta-entrada/puerta-entrada.component';
import { HomenoComponent } from './components/home-no-inq/homeno/homeno.component';
import { InfoArriendoNoComponent } from './components/info-arriendo-no-inq/info-arriendo-no/info-arriendo-no.component';
import { LoadingNoComponent } from './components/loading-no-inq/loading-no/loading-no.component';
import { PlanesnoComponent } from './components/planes-no-inq/planesno/planesno.component';
import { FinFlujoNoComponent } from './components/FinFlujo/fin-flujo-no-inq/fin-flujo-no/fin-flujo-no.component';
import { ArmaPlanNoComponent } from './components/arma-plan-no-inq/arma-plan-no/arma-plan-no.component';

import { APP_BASE_HREF } from '@angular/common';
import {
  INFO_ARRENDAMIENTOS,
  INFO_ARRENDAMIENTOS_NO_IQ,
  LOADING,
  LOADING_NO,
  PLANES_SEGUROS,
  PLANES_NO,
  ARMA_TU_PLAN,
  ARMA_TU_PLAN_NO,
  RESUMEN_COMPRA,
  DURACION_CONTRATO,
  DATOS_PROPIETARIO,
  INMUEBLE,
  DATOS_INQUILINO,
  DATOS_INQUILINO_INICIAL,
  PAGO_EXITOSO,
  PROCESAR_PAGO,
  PAGO_RECHAZADO,
  RESUMEN_PROCESO,
  VERIFICACION_NUM_CELULAR,
  VALIDACION_CODIGO_INQUILINO,
  PREGUNTAS_SEGURIDAD,
  FIRMA_CONTRATO,
  MESSAGES,
  FEEDBACK,
  FIN_FLUJO,
  FIN_FLUJO_PEP,
  FIN_FLUJO_PEMB,
  SCORE_FINANCIERO,
  TIEMPO_INACTIVO,
  NO_SARLAFT,
  NO_VALIDACION_IDENTIDAD,
  CONEXION_INTERRUPIDA,
  ERROR,
  COTIZACION_PAUSA,
  COTIZACION_PAUSA_LEAD2,
  COTIZACION_PAUSA_LEAD3,
  CUMULO,
  LOADER,
  CARD_INMUEBLE,
  MENSAJE_PROPIETARIO,
  PUERTA_ENTRADA,
  INICIO,
  FIN_FLUJO_NO,
  HOME,
  NO_ARRIENDO,
  FINAL_PAGE
} from './routes.constants';
import { finalPagesChildrenRoutes } from './shared/final-pages/final-pages.routes';
import { CotizadorComponent } from './new-flow/pages/cotizador/cotizador.component';

const routes: Routes = [
  { path: INFO_ARRENDAMIENTOS, component: InfoArrendamientosComponent },
  { path: `${INFO_ARRENDAMIENTOS}/:infoCliente`, component: InfoArrendamientosComponent },

  { path: INFO_ARRENDAMIENTOS_NO_IQ, component: InfoArriendoNoComponent },
  { path: `${INFO_ARRENDAMIENTOS_NO_IQ}/:infoCliente`, component: InfoArriendoNoComponent },

  { path: LOADING, component: LoadingComponent },
  { path: `${LOADING}/:infoCliente`, component: LoadingComponent },

  { path: LOADING_NO, component: LoadingNoComponent },
  { path: `${LOADING_NO}/:infoCliente`, component: LoadingNoComponent },

  { path: PLANES_SEGUROS, component: PlanesSegurosComponent },
  { path: `${PLANES_SEGUROS}/:infoCliente`, component: PlanesSegurosComponent },

  { path: PLANES_NO, component: PlanesnoComponent },
  { path: `${PLANES_NO}/:infoCliente`, component: PlanesnoComponent },

  { path: ARMA_TU_PLAN, component: ArmarPlanComponent },
  { path: `${ARMA_TU_PLAN}/:infoCliente`, component: ArmarPlanComponent },

  { path: ARMA_TU_PLAN_NO, component: ArmaPlanNoComponent },
  { path: `${ARMA_TU_PLAN_NO}/:infoCliente`, component: ArmaPlanNoComponent },

  { path: RESUMEN_COMPRA, component: ResumenCompraComponent },
  { path: `${RESUMEN_COMPRA}/:infoCliente`, component: ResumenCompraComponent },
  { path: `${RESUMEN_COMPRA}/:json`, component: ResumenCompraComponent },

  { path: DURACION_CONTRATO, component: DuracionContratoComponent },
  { path: `${DURACION_CONTRATO}/:infoCliente`, component: DuracionContratoComponent },

  { path: DATOS_PROPIETARIO, component: DatosPropietarioComponent },
  { path: `${DATOS_PROPIETARIO}/:infoCliente`, component: DatosPropietarioComponent },

  { path: INMUEBLE, component: InfoInmuebleComponent },
  { path: `${INMUEBLE}/:infoCliente`, component: InfoInmuebleComponent },

  { path: DATOS_INQUILINO, component: DatosInquilinoComponent },
  { path: `${DATOS_INQUILINO}/:infoCliente`, component: DatosInquilinoComponent },

  { path: DATOS_INQUILINO_INICIAL, component: DatosInquilinoInicialComponent },
  { path: `${DATOS_INQUILINO_INICIAL}/:infoCliente`, component: DatosInquilinoInicialComponent },

  { path: PAGO_EXITOSO, component: PagoExitosoComponent },
  { path: `${PAGO_EXITOSO}/:infoCliente`, component: PagoExitosoComponent },

  { path: PROCESAR_PAGO, component: ProcesarPagoComponent },
  { path: `${PROCESAR_PAGO}/:infoCliente`, component: ProcesarPagoComponent },

  { path: PAGO_RECHAZADO, component: PagoRechazadoComponent },
  { path: `${PAGO_RECHAZADO}/:infoCliente`, component: PagoRechazadoComponent },

  { path: RESUMEN_PROCESO, component: ResumenProcesoComponent },
  { path: `${RESUMEN_PROCESO}/:infoCliente`, component: ResumenProcesoComponent },

  { path: VERIFICACION_NUM_CELULAR, component: VerificacionNcelularComponent },
  { path: `${VERIFICACION_NUM_CELULAR}/:infoCliente`, component: VerificacionNcelularComponent },

  { path: VALIDACION_CODIGO_INQUILINO, component: ValidacionCodigoInquilinoComponent },
  { path: `${VALIDACION_CODIGO_INQUILINO}/:infoCliente`, component: ValidacionCodigoInquilinoComponent },

  { path: PREGUNTAS_SEGURIDAD, component: PreguntasSeguridadComponent },
  { path: `${PREGUNTAS_SEGURIDAD}/:infoCliente`, component: PreguntasSeguridadComponent },

  { path: FIRMA_CONTRATO, component: FirmaContratoInquilinoComponent },
  { path: `${FIRMA_CONTRATO}/:infoCliente`, component: FirmaContratoInquilinoComponent },

  { path: MESSAGES, component: MessagesComponent },
  { path: FEEDBACK, component: FeedbackComponent },
  { path: FIN_FLUJO, component: FinFlujoComponent },
  { path: FIN_FLUJO_PEP, component: FinFlujoPEPComponent },
  { path: FIN_FLUJO_PEMB, component: FinFlujoPEmbComponent },
  { path: SCORE_FINANCIERO, component: ScoreFinancieroComponent },
  { path: TIEMPO_INACTIVO, component: TiempoInactivoComponent },
  { path: NO_SARLAFT, component: NoSarlaftComponent },
  { path: NO_VALIDACION_IDENTIDAD, component: NoValidacionIdentidadComponent },
  { path: CONEXION_INTERRUPIDA, component: ConexionInterrumpidaComponent },
  { path: ERROR, component: ErrorComponent },
  { path: COTIZACION_PAUSA, component: CotizacionPausaComponent },
  { path: COTIZACION_PAUSA_LEAD2, component: CotizacionPausa2Component },
  { path: COTIZACION_PAUSA_LEAD3, component: CotizacionPausa3Component },
  { path: CUMULO, component: CumuloComponent },
  { path: LOADER, component: LoadingComponent },
  { path: CARD_INMUEBLE, component: CardInmuebleComponent },
  { path: MENSAJE_PROPIETARIO, component: MensajePropietarioComponent },
  { path: PUERTA_ENTRADA, component: PuertaEntradaComponent },
  { path: INICIO, component: HomenoComponent },
  { path: FIN_FLUJO_NO, component: FinFlujoNoComponent },
  { path: HOME, pathMatch: 'full', component: HomeComponent },
  { path: '', redirectTo: '/seguros/hogar/arriendo/cotizador', pathMatch: 'full' },
  { path: 'seguros/hogar/arriendo/cotizador', pathMatch: 'full', component: CotizadorComponent },
   {
    path: FINAL_PAGE,
    children: finalPagesChildrenRoutes,
  },
  //{ path: '', pathMatch: 'full', component: HomeComponent },

  {
    path: 'seguros/hogar/arriendo/inquilino',
    loadChildren: () => import('./tenant/tenant.module').then(m => m.TenantModule)
  },
  {
    path: 'seguros/hogar/arriendo/sarlaft', 
    loadChildren: () => import('./sarlaft/sarlaft.module').then(m => m.SarlaftModule)
  },
  {
    path: 'seguros/hogar/arriendo/cotizadores',
    loadChildren: () => import('./cotizador/cotizador.module').then(m => m.CotizadorModule)
  },
  {
    path:'seguros/hogar/arriendo/renovaciones',
    loadChildren: () => import('./renewal/renewal.module').then(m => m.RenewalModule)
  },
  {
    path:'new-flow/pages/cotizador',
    loadChildren:()=> import('./new-flow/newflow.module').then(m=>m.NewFlowModule)
  },
  {
    path: NO_ARRIENDO,
    component: HomeComponent,
  },
 
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" }
  ]
})
export class AppRoutingModule { }
